/**
 * Casuki — página de carrito.
 *
 * El formulario usa `updates[]` posicional (estándar de Shopify): cada input
 * de cantidad se envía en el mismo orden que cart.items. Los botones +/-
 * solo tocan el valor del input y disparan el envío del formulario completo,
 * que recalcula todo del lado del servidor (sin riesgo de descuadre de stock
 * o precios).
 */

document.addEventListener('click', (event) => {
  const step = event.target.closest('[data-casuki-cart-step]');
  if (!step) return;

  const row = step.closest('.casuki-cart-line__qty');
  const input = row && row.querySelector('[data-casuki-cart-qty]');
  if (!input) return;

  const delta = Number(step.dataset.casukiCartStep);
  const next = Math.max(0, Number(input.value || 0) + delta);
  input.value = next;
  input.form.requestSubmit();
});

document.addEventListener('change', (event) => {
  const input = event.target.closest('[data-casuki-cart-qty]');
  if (!input) return;
  input.form.requestSubmit();
});
